import React, { useCallback } from "react";
import { UnitsOperationTypeEnum } from "../../../../../../../../Enums";
import { CopyToClipboardComponents } from "../../../../../../../../ReusableComponents/UtilityComponents/CopyToClipboardComponents/CopyToClipboardComponents";

const transactionLinksActionClicked = (item, key) => async (event) => {
  event.stopPropagation();
  if (key === "lead" && item?.leadId && item?.leadType)
    window.open(
      `/home/leads/lead-profile-edit?formType=${
        item?.leadType === "Owner" ? 1 : 2
      }&id=${item.leadId}`,
      "_blank"
    );
  else if (
    key === "unit" &&
    item?.operationTypeId === UnitsOperationTypeEnum.sale.key &&
    item?.unitRefNumber &&
    item?.unitId
  )
    window.open(
      `/home/units-sales/unit-profile-edit?formType=${1}&id=${
        item?.unitId || item?.unitRefNumber
      }&operationType=${UnitsOperationTypeEnum.sale.key}`,
      "_blank"
    );
  else if (
    key === "unit" &&
    item?.operationTypeId === UnitsOperationTypeEnum.rentAndSale.key
  )
    window.open(
      `/home/units-sales/unit-profile-edit?formType=${1}&id=${
        item?.unitId || item?.unitRefNumber
      }&operationType=${UnitsOperationTypeEnum.sale.key}`,
      "_blank"
    );
  else if (
    key === "unit" &&
    item?.operationTypeId === UnitsOperationTypeEnum.rent.key
  )
    window.open(
      `/home/units-lease/unit-profile-edit?formType=${1}&id=${
        item?.unitId || item?.unitRefNumber
      }&operationType=${UnitsOperationTypeEnum.rent.key}`,
      "_blank"
    );
};

export const CommissionsHeaderData = (t, translationPath) => [
  {
    id: 1,
    label: "lead-id",
    input: "leadId",
    isHiddenFilter: false,
    component: (item) =>
      item.leadId ? (
        <a
          className="c-primary newTabActivites"
          onClick={transactionLinksActionClicked(item, "lead")}
        >
          {item.leadId || ""}
        </a>
      ) : (
        <span> {item.leadId || ""} </span>
      ),
  },
  {
    id: 2,
    label: "lead-name",
    input: "lead-name",
    isHiddenFilter: true,
    component: (item) => (
      <span>
        {" "}
        {`${item?.leadFirstName || ""} ${item?.leadLastName || ""}` || ""}{" "}
      </span>
    ),
  },
  {
    id: 3,
    label: "lead-type",
    input: "leadType",
    isHiddenFilter: true,
  },
  {
    id: 4,
    label: "leads-assigned-agent",
    input: "agentName",
    isHiddenFilter: true,
  },
  {
    id: 5,
    label: "transaction-Id",
    input: "transactionId",
    component: (item) => (
      <span className="c-primary">
        {(item && item.transactionId && (
          <CopyToClipboardComponents
            data={item.transactionId}
            childrenData={item.transactionId || ""}
          />
        )) ||
          ""}
      </span>
    ),
    isDefaultFilterColumn: true,
    isHiddenFilter: true,
  },
  {
    id: 6,
    label: "transaction-status",
    input: "transactionStatus",
    isHiddenFilter: true,
    component: (item, index) =>
      item?.transactionStatus === "Approved" ? (
        <div className="pass-lapel" index={index}>
          {item?.transactionStatus}
        </div>
      ) : item?.transactionStatus === "Pending" ? (
        <div className="Pending-lapel" index={index}>
          {item?.transactionStatus}
        </div>
      ) : item?.transactionStatus === "In Review" ? (
        <div className="Fail-lapel" index={index}>
          {item.transactionStatus}{" "}
        </div>
      ) : !item.transactionStatus ? (
        <div index={index}>{""}</div>
      ) : item?.transactionStatus ? (
        <div className="Fail-lapel" index={index}>
          {item.transactionStatus}
        </div>
      ) : (
        ""
      ),
  },
  {
    id: 7,
    label: "transaction-value",
    input: "transactionValue",
    isHiddenFilter: true,
  },
  {
    id: 8,
    label: "unit-ref-number",
    input: "unitRefNumber",
    isHiddenFilter: false,
    component: (item) =>
      item.unitId && item?.operationTypeId ? (
        <a
          className="c-primary newTabActivites"
          onClick={transactionLinksActionClicked(item, "unit")}
        >
          {item.unitRefNumber || ""}
        </a>
      ) : (
        <span> {item?.unitRefNumber || ""} </span>
      ),
  },
  {
    id: 9,
    label: "units-listing-agent",
    input: "listingAgentName",
    isHiddenFilter: true,
  },
  {
    id: 10,
    label: "commission-amount",
    input: "commissionAmount",
    isHiddenFilter: true,
    component: (item) => <span>{item?.commissionAmount || ""}</span>,
  },
  {
    id: 11,
    label: "commission-percentage",
    input: "commissionPercentage",
    isHiddenFilter: true,
    component: (item) => <span>{item?.commissionPercentage || ""}</span>,
  },
  {
    id: 12,
    label: "commission-status",
    input: "commissionStatus",
    isHiddenFilter: false,
    component: (item, index) =>
      item.commissionStatus === "Paid" ? (
        <div className="pass-lapel" index={index}>
          {`${item.commissionStatus}`}
        </div>
      ) : item.commissionStatus === "Pending" ? (
        <div className="Pending-lapel" index={index}>
          {`${item.commissionStatus}`}
        </div>
      ) : item.commissionStatus === "In Review" ? (
        <div className="Fail-lapel" index={index}>
          {`${item.commissionStatus}`}
        </div>
      ) : !item.commissionStatus ? (
        <div className="" index={index}>
          {""}
        </div>
      ) : item.commissionStatus ? (
        <div className="Fail-lapel" index={index}>
          {`${item.commissionStatus}`}
        </div>
      ) : (
        ""
      ),
  },
  {
    id: 13,
    label: "commission-payment-date",
    input: "commissionPaymentDate",
    isHiddenFilter: true,
    isDate: true,
    dateFormat: "DD MMM YYYY HH:MM",
  },
];
